module.exports = __webpack_public_path__ + "static/media/bottom_shape_4.261968be.svg";